import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { APP_CONSTANTS } from 'src/app/core/constants/enum.constants';
import { ToastBody } from 'src/app/core/models/notification.model';
import { ToastComponent } from 'src/app/standalone/components/toast/toast.component';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    constructor(private toastService: ToastrService) {}

    open(toastBody: ToastBody) {
        this.toastService.show(
            toastBody.toastMessage,
            toastBody.toastTitle,
            {
                toastClass: 'custom-toast',
                toastComponent: ToastComponent,
                timeOut: +APP_CONSTANTS.TIMEOUT
            },
            toastBody.toastType
        );
    }
}
